module.exports = __webpack_public_path__ + "static/media/close.b65df71a.png";